// Customizing the axios api calls
import axios from "axios";
import { EventBus } from "../EventBus";
import store from "../store";

const Api = axios.create();

//Api.defaults.headers.post['Content-Type'] = 'application/json';

Api.interceptors.request.use(
  function(config) {
    const token = store.getters.token;
    //for every request add the token to the authorization header
    config.headers.Authorization = token;
    NProgress.start();
    return config;
  },
  function(error) {
    NProgress.done();
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  function(response) {
    NProgress.done();
    return response;
  },
  async function(error) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      const token = await acquireSilentToken();
      originalRequest.headers.Authorization = token;
      return new Promise((resolve, reject) => {
        Api(originalRequest)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
    NProgress.done();
    if (error && error.response && error.response.data) {
      EventBus.$emit("toast", {
        title: "Error",
        message: error.response.data.error.message,
        variant: "danger",
      });
    }
    return Promise.reject(error);
  }
);

let acquireSilentToken = function() {
  return new Promise((resolve) => {
    const config = {
      auth: {
        clientId: process.env.VUE_APP_clientId,
        authority: process.env.VUE_APP_tenant,
        prompt: "select_account",
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
      },
    };
    let uaa = new Msal.UserAgentApplication(config);
    const loginRequest = {
      scopes: process.env.VUE_APP_scopes.split(","),
    };
    uaa
      .acquireTokenSilent(loginRequest)
      .then(function(tokenResponse) {
        var token = tokenResponse.accessToken;
        store.commit("login", token);
        store.commit("user", {
          user: tokenResponse.account,
        });
        resolve(token);
      })
      .catch(function(error) {
        if (error.name === "InteractionRequiredAuthError") {
          return msalnstance
            .acquireTokenPopup(tokenRequest)
            .then(function(tokenResponse) {
              var token = tokenResponse.accessToken;
              store.commit("login", token);
              store.commit("user", {
                user: tokenResponse.account,
              });
              EventBus.$emit("done");
              resolve(token);
            })
            .catch((err) => {
              EventBus.$emit("done");
            });
        } else {
          EventBus.$emit("done");
        }
      });
  });
};

export default Api;
